import { render, staticRenderFns } from "./agingStockPieChart.vue?vue&type=template&id=63aa0376&scoped=true"
import script from "./agingStockPieChart.vue?vue&type=script&lang=js"
export * from "./agingStockPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aa0376",
  null
  
)

export default component.exports